import { render, staticRenderFns } from "./mainBlog.vue?vue&type=template&id=51553948&scoped=true&"
import script from "./mainBlog.vue?vue&type=script&lang=js&"
export * from "./mainBlog.vue?vue&type=script&lang=js&"
import style0 from "./mainBlog.vue?vue&type=style&index=0&id=51553948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51553948",
  null
  
)

export default component.exports